import VueRouter from 'vue-router'
import Vue from 'vue'

const RouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return RouterPush.call(this, to).catch(err => err)
}
const RouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (to) {
  return RouterReplace.call(this, to).catch(err => err)
}

Vue.use(VueRouter);

const routes = [  
  {
    // 配置默认路由
    name:"index",
    path: '/',
    component:() => import('../views/LayoutLogin.vue')
  }, 
  {
    name: "PayWeb",
    path: '/:guid/:prefix?/PayWeb',
    component: () => import('../views/PayWeb.vue')
  },  
  {
    name: "PayWeb1",
    path: '/PayWeb',
    component: () => import('../views/PayWeb.vue')
  }, 
  {
    name:"main",
    path: '/main',      
    component: () => import('../views/LayoutMain.vue'),
    //redirect: '/hello',
    children: [
      {
        name:"hello",
        path: '/hello',
        component: () => import('../views/HelloWorld.vue')
      },{
        name:"popDownTypeList",//字典类型列表
        path: '/popDownTypeList',
        component: () => import('../views/hr/systemSet/popDownType.vue')
      } ,{
        name:"popDownList",//字典类型列表
        path: '/popDownList',
        component: () => import('../views/hr/systemSet/popDown.vue')
      } ,{
        name:"accountList",//用户列表
        path: '/accountList',
        component: () => import('../views/hr/account/accountList.vue')
      } ,{
        name:"moduleList",//模块列表
        path: '/moduleList',
        component: () => import('../views/hr/module/moduleList.vue')
      }, {
        name:"roleList",//权限列表
        path: '/roleList',
        component: () => import('../views/hr/module/roleList.vue')
      },  {
        name:"authorityList",//授权列表
        path: '/authorityList',
        component: () => import('../views/hr/module/authorityList.vue')
      },{
        name:"orderList",//订单列表
        path: '/orderList',
        component: () => import('../views/order/orderList.vue')
      },{
        name:"platformList",//渠道列表
        path: '/platformList',
        component: () => import('../views/platform/platformList.vue')
      },{
        name:"orderRecordList",//流水明细
        path: '/orderRecordList',
        component: () => import('../views/order/orderRecordList.vue')
      }
    ]
  }, {
    name:"login",
    path: '/login',
    component: () => import('../views/LayoutLogin.vue')
  }
  , {
    name:"error",
    path: '/error',
    component: () => import('../components/ErrorIndex.vue')
  },  
]

const router = new VueRouter({
    //base: '/tzweb/',
    mode: 'hash',//hash  history
    routes 
  })

export default router

